import { APP_INITIALIZER, NgModule, Optional, RendererFactory2, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { tawkToFactory } from './init/tawk-to.factory';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [RendererFactory2],
      useFactory: tawkToFactory,
    },
  ],
})
export class CustomerSupportModule {
  public constructor(@Optional() @SkipSelf() module?: CustomerSupportModule) {
    if (module) {
      throw new Error('CustomerSupportModule is already loaded. Import it in the AppModule only');
    }
  }
}
